import { render } from "./ClientCallList.vue?vue&type=template&id=34de3604"
import script from "./ClientCallList.vue?vue&type=script&lang=js"
export * from "./ClientCallList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__